
import React, { useState, useEffect } from 'react';
import Banner from './components/Banner';
import Header from './components/Header';
import Hero from './components/Hero';
import AuthorityBar from './components/AuthorityBar';
import ProblemSection from './components/ProblemSection';
import SolutionSection from './components/SolutionSection';
import WorkflowSection from './components/WorkflowSection';
import ProductShowcase from './components/ProductShowcase';
import TherapyScope from './components/TherapyScope';
import Features from './components/Features';
import PilotOffer from './components/PilotOffer';
import ContactForm from './components/ContactForm';
import Footer from './components/Footer';

const App: React.FC = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen selection:bg-fhir selection:text-white bg-white">
      <Banner />
      <Header scrolled={scrolled} />
      <main>
        <Hero />
        <AuthorityBar />
        <ProblemSection />
        <SolutionSection />
        <WorkflowSection />
        <ProductShowcase />
        <TherapyScope />
        <Features />
        <PilotOffer />
        <ContactForm />
      </main>
      <Footer />
    </div>
  );
};

export default App;
